module.exports = __webpack_public_path__ + "static/media/image4.a59aeeef.png";